import ConnectionService, { HttpMethod } from './connection.service';
import memberStore from '../../stores/member.store';
import { IGithubIntegration } from '../../models/account.model';
import { IGithubRepo } from '../../models/github.model';

class GithubConnection {
  public async getAuthUrl(): Promise<{url: string}> {
    return await ConnectionService.fetch(`integration/github/authUrl`, HttpMethod.GET, {accountId: memberStore.accountId});
  }

  public async listRepos(): Promise<IGithubRepo[]> {
    return await ConnectionService.fetch(`accounts/${memberStore.accountId}/githubIntegration/repos`);
  }

  public async listBranches(owner: string, repo: string): Promise<string[]> {
    return await ConnectionService.fetch(`accounts/${memberStore.accountId}/githubIntegration/branches`, HttpMethod.GET, {owner, repo});
  }

  public async setRepoMapping(appId: string, data: {owner: string, repo: string, branch: string}): Promise<IGithubIntegration> {
    return await ConnectionService.fetch(`accounts/${memberStore.accountId}/githubIntegration/apps/${appId}`, HttpMethod.PUT, data);
  }

  public async deleteRepoMapping(appId: string): Promise<IGithubIntegration> {
    return await ConnectionService.fetch(`accounts/${memberStore.accountId}/githubIntegration/apps/${appId}`, HttpMethod.DELETE);
  }

  public async disconnect(): Promise<void> {
    return await ConnectionService.fetch(`accounts/${memberStore.accountId}/githubIntegration`, HttpMethod.DELETE);
  }
}

export default new GithubConnection();
